import React, { useEffect } from 'react';
import { fetchEnrichments } from '../../data/fetch';
import { useEvent } from '../../data/hooks/eventHooks';
import Loader from './Loader';
import { useStoredDataChanged } from './useStoredDataChanged';

const LoadEnrichments = ({ eventId, children }) => {
    // force reevaluate when an update is received
    useStoredDataChanged();

    return (
        <Loader skipSpinner={(state) => state.events[eventId]?.enrichments.loaded} promises={[fetchEnrichments(eventId)]}>
            {children}
        </Loader>
    );
};

export function ClearEnrichmentsCache(props) {
    const { eventId, children } = props,
        event = useEvent(eventId) ?? {},
        { open_required_enrichments_count, open_enrichments_count } = event;

    // expire enrichments cache if open_required_enrichments_count change
    useEffect(() => {
        fetchEnrichments.cache.clear();
    }, [eventId, open_required_enrichments_count, open_enrichments_count]);

    return children;
}

export default LoadEnrichments;
